import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type { CalendarEvent } from '@wrapforce/shared';
import { workspacePath } from '@wrapforce/shared/api-client';
import { api } from '@/lib/api';

export function useCalendar(workspaceId: string | null, from: string, to: string, locationId?: string) {
  return useQuery({
    queryKey: [workspaceId, 'calendar', from, to, locationId],
    queryFn: () => api.get<CalendarEvent[]>(workspacePath(workspaceId!, '/calendar'), { query: { from, to, locationId } }),
    enabled: !!workspaceId,
    staleTime: 30_000,
    placeholderData: keepPreviousData,
  });
}
